// Desarrollo local: fallback de autenticación cuando no hay variables de Supabase.
// Almacena usuarios en localStorage (iv1_dev_users) y una sesión simple (iv1_dev_session).

const USERS_KEY = 'iv1_dev_users';
const SESSION_KEY = 'iv1_dev_session';

function readUsers() {
  try { return JSON.parse(localStorage.getItem(USERS_KEY) || '[]'); } catch { return []; }
}
function writeUsers(list) {
  try { localStorage.setItem(USERS_KEY, JSON.stringify(list)); } catch {}
}
function setSession(email) {
  try { localStorage.setItem(SESSION_KEY, JSON.stringify({ email, ts: Date.now() })); } catch {}
  try { window.dispatchEvent(new Event('dev-auth:changed')); } catch {}
}
export function clearSession() {
  try { localStorage.removeItem(SESSION_KEY); } catch {}
  try { window.dispatchEvent(new Event('dev-auth:changed')); } catch {}
}
export function getSession() {
  try { const raw = localStorage.getItem(SESSION_KEY); if(!raw) return null; const s = JSON.parse(raw); return s && s.email ? s : null; } catch { return null; }
}
export function devSignUp(email, password) {
  const list = readUsers();
  const exists = list.some(u => (u.email||'').toLowerCase() === String(email||'').toLowerCase());
  if (exists) throw new Error('User already exists');
  list.push({ email, password });
  writeUsers(list);
  // No sesión inmediata (imitando confirmación email). Permitir login luego.
  return true;
}
export function devSignIn(email, password) {
  const list = readUsers();
  const user = list.find(u => (u.email||'').toLowerCase() === String(email||'').toLowerCase());
  if (!user || user.password !== password) throw new Error('Invalid login credentials');
  setSession(user.email);
  return true;
}
export function devCurrentUser() {
  const s = getSession();
  return s ? { id: s.email, email: s.email, email_confirmed_at: new Date().toISOString() } : null;
}

// Utilities for seeding and admin whitelist in dev
export function devEnsureUser(email, password) {
  const list = readUsers();
  const idx = list.findIndex(u => (u.email||'').toLowerCase() === String(email||'').toLowerCase());
  if (idx === -1) {
    list.push({ email, password });
    writeUsers(list);
    return true;
  }
  // Update password if different (dev only)
  if (list[idx].password !== password) {
    list[idx].password = password;
    writeUsers(list);
    return true;
  }
  return false;
}

export function addAdminWhitelist(emails=[]) {
  try {
    const cur = JSON.parse(localStorage.getItem('iv1_admin_emails') || '[]');
    const set = new Set(cur);
    emails.forEach(e => { if (e) set.add(String(e)); });
    localStorage.setItem('iv1_admin_emails', JSON.stringify(Array.from(set)));
    return Array.from(set);
  } catch {
    return [];
  }
}
